var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPlayPadding = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92188 13.9844C2.23438 13.9844 2.5 13.8594 2.8125 13.6797L11.9219 8.41406C12.5703 8.03125 12.7969 7.78125 12.7969 7.36719C12.7969 6.95312 12.5703 6.70312 11.9219 6.32812L2.8125 1.05469C2.5 0.875 2.23438 0.757812 1.92188 0.757812C1.34375 0.757812 0.984375 1.19531 0.984375 1.875V12.8594C0.984375 13.5391 1.34375 13.9844 1.92188 13.9844Z",
    fill: "#E5E4EC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPlayPadding);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-play-padding.a5fdf1250ed96ee1c19a50c5e96c3a79.svg";